import { render, staticRenderFns } from "./UISystemBar.vue?vue&type=template&id=2a77a192&"
import script from "./UISystemBar.vue?vue&type=script&lang=js&"
export * from "./UISystemBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports